var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import MuiTooltip from '@material-ui/core/Tooltip';
import React, { forwardRef, useLayoutEffect, useMemo, useRef, useState, } from 'react';
import { combineClasses, combineProps, logInDev, styled, useForkRef, useRcPortalWindowContext, withDeprecatedCheck, useThemeProps, } from '../../foundation';
import { Mask, tooltipStyle } from './styles';
import { RcTooltipClasses, useTooltipForceHide } from './utils';
var _RcTooltip = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcTooltip' });
    var children = props.children, tooltipForceHide = props.tooltipForceHide, openProp = props.open, onOpen = props.onOpen, onClose = props.onClose, 
    // * that className will pass into children, just pick that and pass into root popper
    // * that also not a props in mui doc  https://material-ui.com/api/tooltip/
    classNameProp = props.className, classesProp = props.classes, PopperPropsProp = props.PopperProps, textColor = props.textColor, color = props.color, ignorePointer = props.ignorePointer, size = props.size, maskProps = props.maskProps, title = props.title, injectGlobalStyle = props.injectGlobalStyle, rest = __rest(props, ["children", "tooltipForceHide", "open", "onOpen", "onClose", "className", "classes", "PopperProps", "textColor", "color", "ignorePointer", "size", "maskProps", "title", "injectGlobalStyle"]);
    var externalWindow = useRcPortalWindowContext().externalWindow;
    var _a = __read(useState(false), 2), isDisabledButton = _a[0], setIsDisabledButton = _a[1];
    var innerRef = useRef(null);
    var tooltipRef = useForkRef(ref, innerRef);
    var classes = useMemo(function () {
        return combineClasses(combineClasses({ popper: classNameProp }, RcTooltipClasses), classesProp);
    }, [classNameProp, classesProp]);
    var PopperProps = useMemo(function () {
        return combineProps({
            container: externalWindow === null || externalWindow === void 0 ? void 0 : externalWindow.document.body,
        }, PopperPropsProp);
    }, [PopperPropsProp, externalWindow === null || externalWindow === void 0 ? void 0 : externalWindow.document.body]);
    var forceHideAdditionProps = useTooltipForceHide({
        ref: innerRef,
        tooltipForceHide: tooltipForceHide,
        open: openProp,
        onClose: onClose,
        onOpen: onOpen,
    });
    var additionProp = forceHideAdditionProps !== null && forceHideAdditionProps !== void 0 ? forceHideAdditionProps : {
        open: openProp,
        onOpen: onOpen,
        onClose: onClose,
    };
    // * use to fix when children button is `disabled` that error in Mui
    // * https://github.com/mui-org/material-ui/blob/next/packages/material-ui/src/Tooltip/Tooltip.js#L269
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useLayoutEffect(function () {
        var childNode = innerRef.current;
        if (isDisabledButton &&
            childNode &&
            childNode.tagName.toLowerCase() === 'button' &&
            childNode.disabled) {
            setIsDisabledButton(true);
            logInDev({
                component: 'RcTooltip',
                message: 'You have set a tooltip on disabled button, A disabled element does not fire events.',
            });
        }
        else if (isDisabledButton) {
            setIsDisabledButton(false);
        }
    });
    return (React.createElement(MuiTooltip, __assign({ ref: tooltipRef, title: isDisabledButton ? '' : title, arrow: true, classes: classes, PopperProps: PopperProps }, additionProp, rest), ignorePointer ? (React.createElement(Mask, __assign({}, maskProps), children)) : (children)));
});
/** @release */
var RcTooltip = styled(withDeprecatedCheck(_RcTooltip, [
    {
        prop: 'injectGlobalStyle',
        time: '2021-3',
        comment: "@deprecated now need anymore */",
    },
], 'RcTooltip'))(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), tooltipStyle);
RcTooltip.defaultProps = {
    placement: 'bottom',
    color: 'neutral.b04',
    textColor: 'neutral.f01',
    size: 'large',
};
RcTooltip.displayName = 'RcTooltip';
export { RcTooltip };
var templateObject_1;
